// extracted by mini-css-extract-plugin
export var buttons = "_a9-0";
export var buttonsActive = "_a9-h";
export var cancelConfirm = "_a9-1";
export var closeButton = "_a9-2";
export var column = "_a9-3";
export var container = "_a9-4";
export var detailHeader = "_a9-6";
export var detailTitle = "_a9-7";
export var detailsContent = "_a9-5";
export var header = "_a9-8";
export var headerWithClose = "_a9-9";
export var icon = "_a9-a";
export var infoIcon = "_a9-c";
export var informationContainer = "_a9-b";
export var sideDrawer = "_a9-d";
export var sideDrawerOpen = "_a9-e";
export var stickyFooter = "_a9-f";
export var typeOption = "_a9-g";